import React, { useCallback } from 'react';
import TailwindScope from '../Shared/TailwindScope';
import { inject, observer } from 'mobx-react';
import AwardPaymentBanner, { AftercareSpecialist } from '../Shared/AwardPaymentBanner';
import { useHistory } from 'react-router-dom';
import PATH from '../../constants/paths';
import TitleBarContext from '../Shared/TitleBarContext';

type AwardPaymentLayoutProps = {
  children: React.ReactNode;
  dataTestId?: string;
  /** When false, the AwardPaymentBanner will not be rendered. Defaults to true. */
  showBanner?: boolean;
  bannerTitle?: string;
  AuthStore?: {
    roles?: string[];
  };
  SeniorStore?: {
    senior?: {
      first_name?: string;
      last_name?: string;
      alumni_updated_first_name?: string;
      alumni_updated_last_name?: string;
      aftercareSpecialistInfo?: AftercareSpecialist;
    };
  };
};

const AwardPaymentLayoutComponent: React.FC<AwardPaymentLayoutProps> = ({
  children,
  dataTestId,
  showBanner = true,
  bannerTitle,
  AuthStore,
  SeniorStore,
}) => {
  const senior = SeniorStore?.senior ?? {};
  const roles = AuthStore?.roles ?? [];
  const history = useHistory();

  const navigateHome = useCallback(() => {
    history.push(PATH.HOME);
  }, [history]);

  return (
    <TailwindScope className='w-full' data-testid={dataTestId}>
      {showBanner && (
        <AwardPaymentBanner
          senior={senior}
          roles={roles}
          aftercareSpecialist={senior.aftercareSpecialistInfo || undefined}
          handleGotoHomepage={navigateHome}
          title={bannerTitle}
        />
      )}
      <div className='flex w-screen items-center justify-center'>
        <TitleBarContext.Provider value={true}>
          <div className='w-full max-w-[1320px]'>{children}</div>
        </TitleBarContext.Provider>
      </div>
    </TailwindScope>
  );
};

const AwardPaymentLayout = inject('AuthStore', 'SeniorStore')(observer(AwardPaymentLayoutComponent));

export default AwardPaymentLayout;
